import styled from 'styled-components';
import { Body, VariationItem, Header } from '../../VariationItem/style';

export const StyledVariationItem = styled.div`
  ${Body} {
    height: 100%;
    margin-bottom: 0;
  }

  ${Header} {
    min-height: 75px;
  }

  ${VariationItem} {
    background-color: #fff;
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  :last-child {
    ${VariationItem} {
      margin-bottom: 0;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/VariationDragDrop/VariationDragDropItem/style.js